import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter } from 'react-router';

import { AppLayout } from './components/AppLayout';
import { LoadingState } from './components/LoadingState';
import { NotFoundPage } from './components/NotFoundPage';

const ScopedLinkPage = lazy(() =>
  import('./features/links/ScopedLinkPage').then((module) => ({
    default: module.ScopedLinkPage,
  })),
);
const AttendanceResponsePage = lazy(() =>
  import('./features/attendance/AttendanceResponsePage').then((module) => ({
    default: module.AttendanceResponsePage,
  })),
);

function LazyRoute({ children }: { children: ReactNode }) {
  return <Suspense fallback={<LoadingState />}>{children}</Suspense>;
}

export function createAppRouter() {
  return createBrowserRouter([
    {
      path: '/',
      element: <AppLayout />,
      children: [
        {
          path: 'links/:token',
          element: (
            <LazyRoute>
              <ScopedLinkPage />
            </LazyRoute>
          ),
        },
        {
          path: 'attendance-response',
          element: (
            <LazyRoute>
              <AttendanceResponsePage />
            </LazyRoute>
          ),
        },
        {
          path: '*',
          element: <NotFoundPage />,
        },
      ],
    },
  ]);
}

export const router = createAppRouter();
